import { ItemRefineSearchJsEnv, QueryParameter, RefineSearchParameter } from "./item_refine_search_js_env"
import { encodeString } from "../../util/browser_util"

export class ItemRefineSearch {
  constructor(private model: ItemRefineSearchJsEnv) {
    this.model = { ...model }
  }

  getModel(): ItemRefineSearchJsEnv {
    return {
      ...this.model
    }
  }

  getRefineSearchParameter(): RefineSearchParameter {
    return {
      ...this.model.refineSearchParameter
    }
  }

  isNoQueryCheck(): boolean {
    const DEFAULT_DELIVERY_ESTIMATE = "0";
    const REFINE_KBN_LAMP = "2";
    const REFINE_KBN_ORANGEBOOK = "3";

    if (
      !this.model.refineSearchParameter.minPriceRange
      && !this.model.refineSearchParameter.maxPriceRange
      && (!this.model.refineSearchParameter.deliveryEstimate || this.model.refineSearchParameter.deliveryEstimate == DEFAULT_DELIVERY_ESTIMATE)
      && !this.model.refineSearchParameter.searchWord
      && (this.model.refineSearchParameter.itemIcon == null || this.model.refineSearchParameter.itemIcon.length == 0)
      && (this.model.refineSearchParameter.tonerInkIcon == null || this.model.refineSearchParameter.tonerInkIcon.length == 0)
      && !this.model.refineSearchParameter.cutTermEndDate
      && !this.model.refineSearchParameter.ctg
      && !this.model.refineSearchParameter.pubPage
      && !this.model.refineSearchParameter.ctgItemCode
      && !this.model.refineSearchParameter.categoryLll
      && !this.model.refineSearchParameter.categoryLl
      && !this.model.refineSearchParameter.categoryL
      && !this.model.refineSearchParameter.categoryM
      && !this.model.refineSearchParameter.categoryS
      && (
        !this.model.refineSearchParameter.refineKbn || !this.model.refineSearchParameter.refineCD1 ||
        (this.model.refineSearchParameter.refineKbn != REFINE_KBN_LAMP &&
          !this.model.refineSearchParameter.refineCD2 &&
          this.model.refineSearchParameter.refineKbn != REFINE_KBN_ORANGEBOOK)
          )
      && !this.model.refineSearchParameter.supplierCd
      && !this.model.refineSearchParameter.supplierSubCd
      && !this.model.refineSearchParameter.regularOdrRulesKbn
      && !this.model.refineSearchParameter.crossSellCd
      && (this.model.refineSearchParameter.brdCategoryM == null || this.model.refineSearchParameter.brdCategoryM.length == 0)
      && (this.model.refineSearchParameter.mkrCategoryM == null || this.model.refineSearchParameter.mkrCategoryM.length == 0)
      && (this.model.refineSearchParameter.series == null || this.model.refineSearchParameter.series.length == 0)
      && (this.model.refineSearchParameter.searchKeyList == null || this.model.refineSearchParameter.searchKeyList.length == 0)
      && (this.model.refineSearchParameter.itemSpec == null || this.model.refineSearchParameter.itemSpec.length == 0)
      && !this.model.refineSearchParameter.exclusionFlg
      && (!this.model.refineSearchParameter.spcialDelivPicExclusionFlg || this.model.refineSearchParameter.spcialDelivPicExclusionFlg != "1")
      && !this.model.refineSearchParameter.printerMaker
      && (!this.model.refineSearchParameter.printerType || this.model.refineSearchParameter.printerType == "0")
      && !this.model.refineSearchParameter.printerModel
      && !this.model.refineSearchParameter.supplierId
      && !this.model.refineSearchParameter.catalogCode
      && (this.model.refineSearchParameter.managementCategoryCodeList == null || this.model.refineSearchParameter.managementCategoryCodeList.length == 0)
      && !this.model.refineSearchParameter.unitPriceCatalogCode
      && !this.model.refineSearchParameter.makerModel
      && this.model.refineSearchParameter.isCbItem == null
      && !this.model.refineSearchParameter.bundleDiscountCpnFlg
    ) {
      return true;
    }
    return false;
  }

  updateSearchParameterFromPopstateEvent(refineSearchParameter: RefineSearchParameter) {
    this.model.refineSearchParameter = refineSearchParameter;
  }

  updateSearchParameter(newParameters: QueryParameter[]) {
    this.setNewPriceRange(newParameters);
    this.resetPage();

    for (const newParameter of newParameters) {
      const key = newParameter.key;
      const newValue = newParameter.value;
      const currentValue = this.model.refineSearchParameter[key];
      const isMultipleValue = Array.isArray(currentValue);

      if (
        (key === 'itemIcon' && newValue === '16010') ||
        (key === 'itemIcon' && newValue === '16020')
      ) {
        const hasCbItem = this.model.refineSearchParameter['isCbItem'] === '1';
        if (hasCbItem) {
          this.model.refineSearchParameter['isCbItem'] = null;
          continue;
        } else {
          this.model.refineSearchParameter['isCbItem'] = '1';
          continue;
        }
      }

      if (key === 'minPriceRange' || key === 'maxPriceRange') continue;

      if (key === 'priceRangeInputFlg') {
        if (this.model.refineSearchParameter[key] === "1") continue;
      }

      if (key === 'lstSelSpecCd' || key === 'resultType') {
        this.model.refineSearchParameter[key] = newValue;
        continue;
      }

      if (key === 'page' || key === 'sortDir' || key === 'resultCount') {
        this.model.refineSearchParameter[key] = Number(newValue);
        continue;
      }

      if (currentValue && !isMultipleValue) {
        this.model.refineSearchParameter[key] = null;
        continue;
      }

      if (currentValue && isMultipleValue) {
        const hasItemAlready = currentValue.indexOf(newValue) > -1;
        if (hasItemAlready) {
          this.model.refineSearchParameter[key] = currentValue.filter(value => value !== newValue);
        } else {
          this.model.refineSearchParameter[key].push(newValue);
        }
        continue;
      }

      if (!currentValue && !isMultipleValue) {
        this.model.refineSearchParameter[key] = newValue;
        continue;
      }

      if (!currentValue && isMultipleValue) {
        this.model.refineSearchParameter[key] = [newValue];
        continue;
      }
    }
  }

  setNewPriceRange(newParameters: QueryParameter[]) {
    const newMinPriceParameter = newParameters.find(newParameter => newParameter.key === 'minPriceRange');
    const newMaxPriceParameter = newParameters.find(newParameter => newParameter.key === 'maxPriceRange');
    const lastSelectedValue = newParameters.find(newParameter => newParameter.key === 'lstSelSpecCd')?.value;

    const newMinPrice = parseInt(newMinPriceParameter?.value ?? '', 10) || null;
    const newMaxPrice = parseInt(newMaxPriceParameter?.value ?? '', 10) || null;

    const currentMinPrice = this.model.refineSearchParameter.minPriceRange || null;
    const currentMaxPrice = this.model.refineSearchParameter.maxPriceRange || null;

    if (lastSelectedValue === "price") {
      if (newMinPrice === currentMinPrice && newMaxPrice === currentMaxPrice) {
        this.model.refineSearchParameter.minPriceRange = null;
        this.model.refineSearchParameter.maxPriceRange = null;
      } else {
        this.model.refineSearchParameter.minPriceRange = newMinPrice;
        this.model.refineSearchParameter.maxPriceRange = newMaxPrice;
      }
    }
  }

  resetPage() {
    this.model.refineSearchParameter.page = 1;
  }

  updateHtmlForRender(htmlForRender: Document) {
    this.model.htmlForRender = htmlForRender;
  }

  updateSelfLink(newSelfLink: string) {
    this.model.selfLink = newSelfLink;
  }

  createSearchUrl() {
    const parameterKeyValueList: string[] = [];

    Object.keys(this.model.refineSearchParameter).forEach((key) => {
      const newValue = this.model.refineSearchParameter[key];
      const isMultipleValue = Array.isArray(newValue);
      if (!isMultipleValue) {
        parameterKeyValueList.push(key.concat('=', this.convertNullToEmptyString(newValue)));
      } else {
        parameterKeyValueList.push(...newValue.map(v => key.concat('=', this.convertNullToEmptyString(v)))); // NOSONAR
      }
    })

    const searchPamameter = this.removeEmptyParameters(parameterKeyValueList);

    if(searchPamameter.length < 1){
      return this.model.selfLink;
    }
    const urlWithoutNocrwl = (this.model.selfLink ?? '').concat('?').concat(searchPamameter.join('&'));
    if(this.isPageParameterOnly(searchPamameter)){
      // パラメータがページ指定のみだった場合はnocrwl=1を付与しない
      return urlWithoutNocrwl;
    } else {
      // ユーザ操作で絞り込みや並び替えが行われたときに対象のページをインデックスさせないためにnocrwl=1を付与する
      // robots.txtにnocrwl=1のパラメータが付いた時にはインデックスさせない設定が記載されているのでこのパラメータをつけたURLはインデックスされなくなる
      return urlWithoutNocrwl.concat('&nocrwl=1');
    }
  }

  convertNullToEmptyString(valueToConvert) {
    return String(valueToConvert) === 'null' ? '' : encodeString(valueToConvert);
  }

  removeEmptyParameters(parameterList: string[]): string[] {
    return parameterList
      .filter(parameter => parameter.split('=')[1] !== '')
  }

  removePageParameter() {
    this.model.refineSearchParameter['page'] = null;
  }

  isPageParameterOnly(searchPamameter: string[]): boolean {
    return searchPamameter.length === 1 && searchPamameter[0].split('=')[0] === 'page'
  }

  getLoadingSpinnerHtml() {
    const loadingSpinnerOverlay = document.createElement('div');
    loadingSpinnerOverlay.setAttribute('style', 'position: fixed; left: 0px; top: 0px; width: 100%; height: 100%; z-index: 9999; background-color: rgba(255, 255, 255, 0.7);');
    loadingSpinnerOverlay.id = 'item_refine_search_loading_spinner';

    const loadingSpinnerContainer = document.createElement('div');
    loadingSpinnerContainer.setAttribute('style', 'position: absolute; left: 0px; top: 0px; right: 0px; bottom: 0px; margin: auto;');
    loadingSpinnerContainer.className = 'a-spinner';

    const loadingSpinner = document.createElement('div');
    loadingSpinner.className = 'a-spinner_inner';

    loadingSpinnerOverlay.append(loadingSpinnerContainer);
    loadingSpinnerContainer.append(loadingSpinner);
    return loadingSpinnerOverlay;
  }

  showLoadingSpinner() {
    const loadingSpinner = this.getLoadingSpinnerHtml();
    document.body.append(loadingSpinner);
  }

  hideLoadingSpinner() {
    document.getElementById('item_refine_search_loading_spinner')?.remove();
  }

  isKeywordSearch(): boolean {
    return this.model.selfLink?.indexOf('/ksearch/') === 0;
  }

  isLKeywordSearch(): boolean {
    return this.model.selfLink?.indexOf('/lksearch/') === 0;
  }

  isCategoryMSearch(): boolean {
    return this.model.selfLink?.indexOf('/m/') === 0;
  }

  isCategorySSearch(): boolean {
    return this.model.selfLink?.indexOf('/s/') === 0;
  }
}
